export default __webpack_public_path__ + "static/media/checked.6821870b.svg";